import { dayNo, fdw } from '../home/view';

// TODO: hồ sơ thật khi có dữ liệu HR (A). Số MẪU theo script board Mint-Mee (khối "Hồ sơ & giấy tờ"); chỉ của chính người xem.

export type ContractState = 'ok' | 'sign' | 'end';

export interface Contract {
  k: string;
  code: string;
  state: ContractState;
}

/** Hợp đồng của người mẫu; `signed` = đã ký phụ lục (phiên hiện tại). */
export function contractsOf(id: string, signed: boolean): Contract[] {
  if (id === 'DAVID') {
    return [
      { k: 'HĐLĐ không xác định thời hạn', code: 'HDLD · hiệu lực từ 04/Mar/2021', state: 'ok' },
      { k: 'Phụ lục điều chỉnh chức danh', code: 'PL-2610-007 · phát hành 20/Oct/2026', state: signed ? 'ok' : 'sign' },
    ];
  }
  return [
    { k: 'HĐLĐ xác định thời hạn 24 tháng', code: 'HDLD · 15/Jan/2025 → 14/Jan/2027', state: 'ok' },
    { k: 'HĐ thử việc', code: 'HDTV · 15/Nov/2024 → 14/Jan/2025', state: 'end' },
  ];
}

const PAPERS: Record<string, ReadonlyArray<readonly [string, string, number]>> = {
  DAVID: [
    ['Chứng chỉ đại lý hải quan', '2026-11-11', 730],
    ['Khám sức khoẻ định kỳ', '2026-11-30', 365],
    ['Thẻ BHYT', '2026-12-31', 365],
    ['Hộ chiếu', '2029-08-14', 3650],
  ],
  MAITTN: [
    ['Chứng chỉ tư vấn HS & C/O', '2028-10-15', 730],
    ['Khám sức khoẻ định kỳ', '2026-11-05', 365],
    ['Thẻ BHYT', '2026-12-31', 365],
    ['Chứng chỉ FIATA module 1', '2026-10-20', 730],
  ],
};

/** nhắc gia hạn khi còn ≤ 30 ngày (board: "Nhắc gia hạn 30 ngày trước hạn") */
export const REMIND_DAYS = 30;

export interface Paper {
  k: string;
  exp: string;
  /** số ngày còn lại (âm = quá hạn) */
  left: number;
  /** tỉ lệ vòng tròn 0.04–1 */
  ring: number;
  tone: 'ok' | 'warn' | 'err';
  badge: string;
  soon: boolean;
}

export function papersOf(id: string, today: string): Paper[] {
  return (PAPERS[id] ?? PAPERS.MAITTN!).map(([k, exp, span]) => {
    const n = dayNo(exp) - dayNo(today);
    const tone = n < 0 ? 'err' : n <= REMIND_DAYS ? 'warn' : 'ok';
    return {
      k,
      exp: `Hết hạn ${fdw(exp).slice(3)}`,
      left: n,
      ring: Math.max(0.04, Math.min(1, n / span)),
      tone,
      badge: n < 0 ? `Quá hạn ${-n} ngày` : `Còn ${n} ngày`,
      soon: n <= REMIND_DAYS,
    };
  });
}

/** Thông tin nhạy cảm: chỉ hiện trên máy chính chủ sau passkey → luôn che. */
export const SECRETS = ['Số CCCD', 'Ngày sinh', 'Điện thoại', 'Email cá nhân', 'Tài khoản nhận lương'] as const;

export const PAPER_KINDS = ['Chứng chỉ nghiệp vụ', 'Khám sức khoẻ định kỳ', 'Thẻ BHYT', 'Hộ chiếu', 'Giấy phép lái xe'] as const;

/** Loại giấy tờ chọn sẵn khi gia hạn một giấy: khớp từ đầu tiên của tên (như board). */
export function kindFor(paper: string | undefined): string {
  if (!paper) return PAPER_KINDS[0];
  return PAPER_KINDS.find((k) => paper.includes(k.split(' ')[0]!)) ?? PAPER_KINDS[0];
}
